import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { CasRHFPercentField, CasStackRow } from 'src/compass/shared/components';
import { CasRHFRiskWithSalesManagerSelect } from 'src/compass/application/general/components/CasRiskWithSalesManagerSelect';

type FieldProps = {
  asofReadonly: boolean;
};

export default function AccountAgreementAndPercentFields({
  asofReadonly,
}: FieldProps) {
  const triggerFields = ['asOf.agreementEmployeeId', 'asOf.agreementPercent'];
  
  const { control, trigger } = useFormContext();

  const [agreementEmployeeId, agreementPercent] = useWatch({
    control,
    name: triggerFields,
  });

  useEffect(() => {
    if (agreementEmployeeId !== undefined && agreementPercent !== undefined) trigger(triggerFields);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agreementEmployeeId, agreementPercent, trigger]);

  return (
    <CasStackRow gapSize="none">
      <CasRHFRiskWithSalesManagerSelect
        includeNoneOption
        name="asOf.agreementEmployeeId"
        label="Agreement Employee"
        disabled={asofReadonly}
      />
      <CasRHFPercentField name="asOf.agreementPercent" label="Agreement" disabled={asofReadonly} />
    </CasStackRow>
  );
}
